import { Modal, ModalDialog, Typography, Button, Box, Stack, Sheet } from '@mui/joy';
import { Rocket, Clock, BookOpen, Exam, Trophy } from '@phosphor-icons/react';

// Pre-tour explainer modal. Shown right after WelcomeModal survey completes,
// before the OnboardingTour starts.
//
// Rules:
//   - No X / close button.
//   - Backdrop click does NOT close.
//   - Single CTA «Погнали» — clicking it hands off to OnboardingTour.
//
// Copy is deliberately short — the tour itself explains the details.

export default function DemoExplainerModal({ open, onStart }) {
    return (
        <Modal
            open={open}
            // Intentionally no onClose — this modal is not dismissable.
            // Clicking the backdrop or pressing Escape does nothing.
            disableEscapeKeyDown
        >
            <ModalDialog
                sx={{
                    maxWidth: 460,
                    width: '90vw',
                    p: 4,
                    textAlign: 'center',
                    borderRadius: 'xl',
                }}
            >
                <Box sx={{ mb: 2 }}>
                    <Rocket size={48} color="#DA7756" weight="duotone" />
                </Box>

                <Typography level="h3" sx={{ mb: 1 }}>
                    Ты в демо-режиме
                </Typography>

                <Typography level="body-md" color="neutral" sx={{ mb: 2.5 }}>
                    5 дней полного доступа к Day 1 Биохимии и Иммунологии
                </Typography>

                <Sheet
                    variant="soft"
                    sx={(theme) => ({
                        bgcolor: theme.palette.mode === 'dark' ? 'rgba(218,119,86,0.08)' : '#FFF8F0',
                        border: '1.5px solid #DA7756',
                        borderRadius: 'md',
                        p: 2,
                        mb: 3,
                        textAlign: 'left',
                    })}
                >
                    <Typography
                        level="body-sm"
                        fontWeight={700}
                        sx={{ color: '#DA7756', mb: 1.25 }}
                    >
                        Что тебе открыто:
                    </Typography>
                    <Stack spacing={1}>
                        <Stack direction="row" spacing={1.25} alignItems="center">
                            <BookOpen size={18} color="#DA7756" weight="duotone" />
                            <Typography level="body-xs" color="neutral">
                                Текстовые модули — теория в удобном формате
                            </Typography>
                        </Stack>
                        <Stack direction="row" spacing={1.25} alignItems="center">
                            <Exam size={18} color="#DA7756" weight="duotone" />
                            <Typography level="body-xs" color="neutral">
                                Мини-тесты — закрепи прочитанное
                            </Typography>
                        </Stack>
                        <Stack direction="row" spacing={1.25} alignItems="center">
                            <Trophy size={18} color="#DA7756" weight="duotone" />
                            <Typography level="body-xs" color="neutral">
                                Клинические задачи — UWorld-style виньетки
                            </Typography>
                        </Stack>
                    </Stack>
                </Sheet>

                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    justifyContent="center"
                    sx={{ mb: 2.5 }}
                >
                    <Clock size={16} color="#787774" />
                    <Typography level="body-xs" color="neutral">
                        Сейчас покажу как всё устроено — 5 шагов, 2 минуты
                    </Typography>
                </Stack>

                <Button
                    variant="solid"
                    size="lg"
                    onClick={onStart}
                    fullWidth
                    sx={{
                        bgcolor: '#DA7756',
                        color: '#FFFFFF',
                        fontWeight: 700,
                        borderRadius: 'lg',
                        py: 1.5,
                        fontSize: '1rem',
                        '&:hover': { bgcolor: '#C4623E' },
                    }}
                >
                    Погнали
                </Button>
            </ModalDialog>
        </Modal>
    );
}
